<nav class="bg-white dark:bg-qo-dark-800 w-full h-full fixed px-4 py-6 flex flex-col inset-0 z-50">

  <p class="mb-6 text-center"><button class="inline-block hover:opacity-60">
      <ng-container *ngTemplateOutlet="logo"></ng-container>
    </button></p>

  <ul class="flex flex-col flex-1 items-start space-y-4 text-2xl overflow-auto mt-6 -mr-4 pr-4 pb-2 min-h-100">
    <li class="w-full"><button class="font-medium block w-full py-2 text-left"
        [mat-dialog-close]="NavigationService.Routes.Home()" i18n>Accueil</button></li>
    <li class="w-full"><button class="font-medium block w-full py-2 text-left"
        [mat-dialog-close]="NavigationService.Routes.AboutUs()" i18n>Découvrir Quick-Off</button></li>
    <li class="w-full" (click)="displayProducts = !displayProducts" aria-controls="mobile-products-menu"
      [attr.aria-expanded]="displayProducts">
      <span
        class="flex items-center cursor-pointer font-medium transition-all duration-200 hover:text-qo-primary dark:hover:text-qo-primary-200 py-2 w-full"
        href="#">
        <ng-container i18n>Solutions</ng-container>
        <mat-icon class="ml-1 transition-all duration-200 material-icons-outlined" role="img" aria-hidden="true"
          [ngClass]="{'rotate-180':displayProducts}">expand_more</mat-icon>
      </span>
      <div id="mobile-products-menu" [attr.aria-hidden]="!displayProducts"
        class="text-lg transition-all duration-200 overflow-hidden" [ngClass]="{
              'max-h-72':displayProducts,
              'max-h-0':!displayProducts
          }">
        <ul class="qo-IconMenu mt-4">
          <li class="w-full">
            <button class="group flex items-center py-1 w-full gap-3 text-left"
              [mat-dialog-close]="NavigationService.Routes.Qomeet()">
              <img class="h-10" src="assets/images/qomeet-square.svg" alt="" />
              <div>
                <picture>
                  <source srcset="assets/images/logo-qomeet-w.svg" media="(prefers-color-scheme: dark)" />
                  <source srcset="assets/images/logo-qomeet.svg" media="(prefers-color-scheme: light)" />
                  <img class="h-4 -mb-1" src="assets/images/logo-qomeet.svg" alt="qomeet" />
                </picture>
              </div>
            </button>
          </li>
          <li class="w-full">
            <button class="group flex items-center py-1 w-full gap-3 text-left"
              [mat-dialog-close]="NavigationService.Routes.Qoezion()">
              <img class="h-10" src="assets/images/qoezion-square.svg" alt="" />
              <div>
                <picture>
                  <source srcset="assets/images/logo-qoezion-w.svg" media="(prefers-color-scheme: dark)" />
                  <source srcset="assets/images/logo-qoezion.svg" media="(prefers-color-scheme: light)" />
                  <img class="h-4 -mb-1" src="assets/images/logo-qoezion.svg" alt="qoezion" />
                </picture>
              </div>
            </button>
          </li>
          <li class="w-full">
            <button class="group flex items-center py-1 w-full gap-3 text-left"
              [mat-dialog-close]="NavigationService.Routes.ProjectManagement()">
              <img class="h-10" src="assets/images/accompagnement-square.svg" alt="" />
              <div>
                <p class="text-lg font-bold -mb-1" i18n>Gestion événementielle</p>
              </div>
            </button>
          </li>
        </ul>
      </div>
    </li>
    <li class="w-full"><button class="font-medium block w-full py-2 text-left"
        [mat-dialog-close]="NavigationService.Routes.Customers()" i18n>Clients</button></li>
    <li class="w-full"><button class="font-medium block w-full py-2 text-left"
        [mat-dialog-close]="NavigationService.Routes.CustomerSupport()" i18n>Accompagnement</button></li>
    <li *ngIf="locale === 'fr'" class="w-full">
      <span
        class="flex items-center cursor-pointer font-medium transition-all duration-200 hover:text-qo-primary dark:hover:text-qo-primary-200 py-2 w-full"
        (click)="displayResources = !displayResources" aria-controls="mobile-resources-menu"
        [attr.aria-expanded]="displayResources">
        <ng-container i18n>Ressources</ng-container>
        <mat-icon class="ml-1 transition-all duration-200 material-icons-outlined" role="img" aria-hidden="true"
          [ngClass]="{'rotate-180':displayResources}">expand_more</mat-icon>
      </span>
      <div id="mobile-resources-menu" [attr.aria-hidden]="!displayResources"
        class="text-lg transition-all duration-200 overflow-hidden" [ngClass]="{
              'max-h-72':displayResources,
              'max-h-0':!displayResources
          }">
        <nav>
          <ul class="qo-IconMenu mt-2">
              <li class="mb-4">
                  <a class="flex items-center gap-3" [href]="ressourcesAccreditationGuideLink" target="_blank"><mat-icon class="material-icons-outlined" role="img" aria-hidden="true">assignment_ind</mat-icon><span class="leading-none">Guide sur l'accréditation événementielle</span></a>
              </li>
              <li class="mb-4">
                  <a class="flex items-center gap-3" [href]="ressourcesVolunteerStudyLink" target="_blank"><mat-icon class="material-icons-outlined" role="img" aria-hidden="true">description</mat-icon><span class="leading-none">Etude sur le bénévolat événementiel 2025</span></a>
              </li>
              <li class="mb-4">
                  <a class="flex items-center gap-3" [href]="ressourcesVolunteeringLegalLink" target="_blank"><mat-icon class="material-icons-outlined" role="img" aria-hidden="true">policy</mat-icon><span class="leading-none">Repères juridiques et bonnes pratiques du bénévolat</span></a>
              </li>
          </ul>
        </nav>
      </div>
    </li>
    <li><a class="py-2" [href]="environmentSettings.BlogUrl" i18n>Blog</a></li>
  </ul>

  @if(locale === 'fr') {
    <a matRipple class="qo-MainBtn w-auto mx-auto" href="https://webforms.pipedrive.com/f/72vCIPRtXsD72MgIlHMn313jMMKYYYTgRCdXjmVTOSc0ZSeYdqQs61fKzVzVxLymUb" target="_blank" i18n>Contactez-nous</a>
  } 
  @else {
    <button matRipple class="qo-MainBtn w-auto mx-auto" [mat-dialog-close]="NavigationService.Routes.Contact()" i18n>Contactez-nous</button>
  }

  <button matRipple mat-dialog-close
    class="flex items-center justify-center bg-qo-text dark:bg-black self-center w-12 h-12 rounded-full text-white mt-4 -mb-2 shadow-md border border-solid border-white">
    <mat-icon class="material-icons-outlined">close</mat-icon>
  </button>

</nav>

<ng-template #logo>
  <img class="h-8" src="assets/images/logo-quick-off.svg" alt="Quick-Off" />
</ng-template>
